// Environment configuration with fallbacks for development
export const env = {
  // Supabase configuration with fallbacks
  SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL || 'https://demo.supabase.co',
  SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY || 'demo-key',
  
  // Turnstile configuration
  TURNSTILE_SITE_KEY: import.meta.env.VITE_TURNSTILE_SITE_KEY || '',
  
  // 🎯 HACKATHON FEATURE: Easy Turnstile toggle
  // Set VITE_DISABLE_CAPTCHA=true to disable CAPTCHA for hackathon judging
  // Can also be controlled via localStorage key 'nosh_disable_captcha'
  get DISABLE_CAPTCHA() {
    const envDisabled = import.meta.env.VITE_DISABLE_CAPTCHA === 'true';
    const localStorageDisabled = typeof window !== 'undefined' && localStorage.getItem('nosh_disable_captcha') === 'true';
    
    console.log('🔍 [CAPTCHA] Env:', envDisabled, 'localStorage:', localStorageDisabled);
    
    return envDisabled || localStorageDisabled;
  },
  
  // Check if we have real Supabase credentials
  HAS_SUPABASE_CONFIG: !!(import.meta.env.VITE_SUPABASE_URL && import.meta.env.VITE_SUPABASE_ANON_KEY),
  
  // Development flags
  IS_DEVELOPMENT: import.meta.env.DEV,
  IS_PRODUCTION: import.meta.env.PROD,
};

// Log configuration status
if (env.IS_DEVELOPMENT) {
  console.log('🔧 Development Environment Configuration:');
  console.log(`   Supabase: ${env.HAS_SUPABASE_CONFIG ? '✅ Configured' : '⚠️ Using demo mode'}`);
  console.log(`   🎯 CAPTCHA: ${env.DISABLE_CAPTCHA ? '🚫 DISABLED (Hackathon Mode)' : '✅ Enabled'}`);
  
  if (!env.HAS_SUPABASE_CONFIG) {
    console.log('💡 To enable full functionality, create a .env.local file with:');
    console.log('   VITE_SUPABASE_URL=your_supabase_project_url');
    console.log('   VITE_SUPABASE_ANON_KEY=your_supabase_anon_key');
  }
}

// Helper function to check CAPTCHA status dynamically
export const isCaptchaDisabled = () => {
  const envDisabled = import.meta.env.VITE_DISABLE_CAPTCHA === 'true';
  const localStorageDisabled = typeof window !== 'undefined' && localStorage.getItem('nosh_disable_captcha') === 'true';
  
  if (env.IS_DEVELOPMENT) {
    console.log('🔍 CAPTCHA Check:', {
      envDisabled,
      localStorageDisabled,
      result: envDisabled || localStorageDisabled
    });
  }
  
  return envDisabled || localStorageDisabled;
};

// Production logging for CAPTCHA status
if (env.IS_PRODUCTION && env.DISABLE_CAPTCHA) {
  console.log('🎯 HACKATHON MODE: CAPTCHA is disabled for easy judge access');
} 